// @flow

// Libs
import _omit from 'lodash/omit'

// Decoders
import decoder from './decoder'

// Model Properties
import {
  PROP_SOIL_JOB_ID,
} from 'hfty-model-soil-jobs'

// Exports
export default _omit(decoder, PROP_SOIL_JOB_ID)
